import { createContext, useContext, useEffect, useState, useCallback, useRef } from "react";
import { api } from "@/lib/api";

const WatchlistContext = createContext(null);

export function WatchlistProvider({ children }) {
  const [watchlist, setWatchlist] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const saveTimer = useRef(null);

  useEffect(() => {
    api.get("/prefs/watchlist")
      .then(({ data }) => setWatchlist(data.watchlist || []))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const persist = useCallback((next) => {
    clearTimeout(saveTimer.current);
    saveTimer.current = setTimeout(() => {
      api.put("/prefs/watchlist", { watchlist: next }).catch(() => {});
    }, 400);
  }, []);

  const toggle = useCallback((id) => {
    setWatchlist((prev) => {
      const next = prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id];
      persist(next);
      return next;
    });
  }, [persist]);

  const has = useCallback((id) => watchlist.includes(id), [watchlist]);

  return (
    <WatchlistContext.Provider value={{ watchlist, loaded, toggle, has, isEmpty: watchlist.length === 0 }}>
      {children}
    </WatchlistContext.Provider>
  );
}

export const useWatchlist = () => {
  const ctx = useContext(WatchlistContext);
  if (!ctx) throw new Error("useWatchlist must be used within WatchlistProvider");
  return ctx;
};
